import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import { Badge } from '@marvelapp/ballpark-components';
import { AtIcon } from '@marvelapp/ballpark-icons';
import { CopyToClipboardButton } from '../CopyToClipboadButton';
export const EmailCell = observer(function EmailCell({ value, }) {
    return (_jsxs(Badge, { variant: "sky", leadingIcon: _jsx(AtIcon, {}), truncate: true, className: "max-w-60", children: [value, _jsx(CopyToClipboardButton, { text: value })] }));
});
